import QueryParams from '~/services/QueryParams';

const parseUTM = (): Record<
  | 'campaign_id'
  | 'ad_id'
  | 'source'
  | 'medium'
  | 'term'
  | 'ad_name'
  | 'campaign_name'
  | 'adset_name'
  | 'adset_id'
  | 'placement'
  | 'network',
  string
> | null => {
  const queryParams = QueryParams.getAllQueryParams();

  const hasUTM = Object.keys(queryParams).some((key) => key.startsWith('utm_'));

  if (!hasUTM) return null;

  return {
    campaign_id: QueryParams.getQueryParam('utm_campaign') || 'not set',
    ad_id: QueryParams.getQueryParam('utm_content') || 'not set',
    source: QueryParams.getQueryParam('utm_source') || 'not set',
    medium: QueryParams.getQueryParam('utm_medium') || 'not set',
    term: QueryParams.getQueryParam('utm_term') || 'not set',
    ad_name: QueryParams.getQueryParam('utm_ad_name') || 'not set',
    campaign_name: QueryParams.getQueryParam('utm_campaign_name') || 'not set',
    adset_name: QueryParams.getQueryParam('utm_adset_name') || 'not set',
    adset_id: QueryParams.getQueryParam('utm_adset_id') || 'not set',
    placement: QueryParams.getQueryParam('utm_placement') || 'not set',
    network: QueryParams.getQueryParam('utm_network') || 'not set',
  };
};

export default parseUTM;
